<template>
    <div>
        <v-dialog v-model="open" persistent max-width="600" scrollable>
            <v-card>
                <v-toolbar :elevation="0" color="primary" dark>
                    <v-toolbar-title v-if="id">Editar Planta</v-toolbar-title>
                    <v-toolbar-title v-else>Añadir Planta</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="close">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text v-if="!register" class="text-right mt-4">
                    <v-text-field
                        v-model="gateway.id"
                        label="Gateway"
                        class="mt-3"
                        :disabled="register"
                        append-icon="mdi-identifier"
                        outlined
                        flat
                        dense
                        solo
                        hide-details
                    ></v-text-field>
                    <v-text-field
                        v-model="gateway.key"
                        label="Llave"
                        class="mt-3"
                        :disabled="register"
                        append-icon="mdi-key"
                        outlined
                        flat
                        dense
                        solo
                        hide-details
                    ></v-text-field>
                    <v-btn 
                        :loading="loading.register" 
                        color="accent"
                        class="mt-8" 
                        :disabled="gateway.id === '' || gateway.key === ''"
                        @click="registerGateway"
                    >
                        Registrar
                    </v-btn>
                </v-card-text>
                <v-card-text style="max-height: 70vh" v-if="register">
                    <v-form ref="form" class="text-center">
                        <v-card flat>
                            <v-card-text>
                                <v-row>
                                    <v-col>
                                        <v-toolbar flat outlined dense class="rounded-lg">
                                            {{ gateway.id }}
                                            <v-spacer></v-spacer>
                                            <v-icon color="accent">
                                                mdi-check-circle
                                            </v-icon>
                                        </v-toolbar>
                                    </v-col>
                                </v-row> 
                                <v-row>
                                    <v-col>
                                        <v-text-field
                                            v-model="data.name"
                                            label="Nombre del circuito"
                                            :disabled="!register"
                                            outlined
                                            flat
                                            dense
                                            solo
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-text-field
                                            v-model="data.description"
                                            label="Descripción del circuito"
                                            :disabled="!register"
                                            outlined
                                            flat
                                            dense
                                            solo
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pb-0">
                                        <v-text-field
                                            v-model="data.location"
                                            label="Coordenadas"
                                            :disabled="!register"
                                            hint="Ejemplo: 25.661483,-100.399966"
                                            outlined
                                            flat
                                            dense
                                            solo
                                            @blur="findAddress"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col class="pb-0">
                                        <v-select
                                            v-model="data.rate"
                                            :items="rates"
                                            label="Tarifas"
                                            :disabled="!register"
                                            outlined
                                            flat
                                            dense
                                            solo
                                            hide-details
                                        ></v-select>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pt-0">
                                        <v-text-field
                                            v-model="data.address"
                                            label="Dirección"
                                            :disabled="!register"
                                            readonly
                                            outlined
                                            flat
                                            dense
                                            solo
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <GmapMap
                                            :center="map.center || {
                                                lat: profile.location.latitude,
                                                lng: profile.location.longitude,
                                            }"
                                            :zoom="17"
                                            :options="{
                                                zoomControl: false,
                                                mapTypeControl: false,
                                                scaleControl: false,
                                                streetViewControl: false,
                                                rotateControl: false,
                                                fullscreenControl: false,
                                            }"
                                            map-type-id="roadmap"
                                            class="map"
                                        >

                                            <GmapMarker
                                                v-if="map.marker"
                                                :position="map.marker"
                                            />
                                            
                                        </GmapMap>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-text-field
                                            v-model="data.panels"
                                            label="Numero de paneles"
                                            :disabled="!register"
                                            type="number"
                                            outlined
                                            flat
                                            dense
                                            solo
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                    <v-col>
                                        <v-text-field
                                            v-model="data.inverters"
                                            label="Numero de inversores"
                                            :disabled="!register"
                                            type="number"
                                            outlined
                                            flat
                                            dense
                                            solo
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <template>
                                            <v-file-input 
                                            ref="image"
                                            v-model="data.image"
                                            accept="image/*" 
                                            label="Adjuntar foto"
                                            :disabled="!register"
                                            prepend-inner-icon="mdi-image"
                                            filled
                                            prepend-icon=""
                                            outlined
                                            flat
                                            dense
                                            solo
                                            hide-details>
                                            </v-file-input>
                                        </template>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions v-if="register">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        class="mr-2"
                        outlined
                        @click="close"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn 
                        :loading="loading.save" 
                        color="accent" 
                        :disabled="
                            data.name === '' ||
                            data.address === '' ||
                            data.location === '' ||
                            data.inverters === null ||
                            data.panels === null ||
                            data.rate === null
                        "
                        @click="edit"
                    >
                        Guardar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="error.active" :timeout="3000">
            {{ error.message }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="error"
                    text
                    v-bind="attrs"
                    @click="error.active = false"
                >
                    Cerrar
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import { RATES } from '../plugins/rates'
import { gmapApi } from 'vue2-google-maps'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
    name: 'formMeters',
    props: ['open', 'id'],
    computed:{
        google: gmapApi,
        ...mapGetters({ 
            getGateway: 'gateways/getGateway',
            getMeters: 'meters/getMetersGtw'
        }),
        ...mapState({ profile: state => state.account.profile })
    },
    data() {
        return {
            rates: RATES,
            register: false,
            gateway: {
                id: '',
                key: ''
            },
            data:{
                name: '', 
                description: '', 
                address: '',
                location: '',
                inverters: null,
                panels: null, 
                rate: null,
                image: null
            },
            map:{
                center: null,
                marker: null
            },
            loading:{
                register: false,
                save: false
            },
            error: {
                message: '',
                active: false
            }
        }
    },
    methods: {
        ...mapActions({ 
            addGateway: 'gateways/addGateway',
            editGateway: 'gateways/editGateway'
        }),
        async registerGateway(){
            if(this.gateway.id === '' || this.gateway.key === '') {
                this.error.message = 'Ingrese gateway y la key'
                this.error.active = true
                return
            }
            try {
                this.loading.register = true
                await this.addGateway({
                    gateway: this.gateway,
                    data: {
                        name: this.gateway.id, 
                        description: this.gateway.id,
                        location: '',
                        inverters: 1,
                        panels: 1, 
                        rate: this.rates[1].text
                    }
                })
                this.register = true
                this.loading.register = false
            } catch (error) {
                console.log(error)
                if(error.response)
                    this.error.message = error.response.data.data
                else
                    this.error.message = 'Verifique los datos'
                this.error.active = true
                this.loading.register = false
            }
        },
        async edit(){
            try {
                this.loading.save = true

                await this.editGateway({
                    gateway: this.gateway,
                    data: this.data
                })

                this.loading.save = true
            } catch (error) {
                console.log(error)
            }
            
            this.close()
        },
        findAddress(){
            try {
                if(this.data.location === '') return
                let coordinates = this.data.location.split(',').map( l => parseFloat(l))
                if(coordinates.some(isNaN) || coordinates.length !== 2) {
                    this.map.marker = null
                    this.map.center = null
                    this.data.address = ''
                }

                const geocoder = new this.google.maps.Geocoder()
                const latlng = {
                    lat: coordinates[0],
                    lng: coordinates[1],
                }
                geocoder.geocode({location: latlng}, (result, status) => {
                    if(status === 'OK'){
                        this.map.marker = latlng
                        this.map.center = latlng
                        this.data.address = result[0].formatted_address
                    }
                })

            } catch (error) {
                console.log(error)
            }
        },
        close(){
            this.reset()
            this.$emit('close')
        },
        reset(){
            this.register = false
            this.gateway = {
                id: '',
                key: ''
            }
            this.data = {
                name: '', 
                description: '', 
                address: '',
                location: '',
                inverters: null,
                panels: null, 
                rate: null,
                image: null
            }
            this.map = {
                center: null,
                marker: null
            }
            this.loading = {
                register: false,
                save: false
            }
        }
    },
    watch:{
        id(){
            if(this.id){
                const gtw = this.getGateway(this.id)

                this.gateway.id = gtw.id
                this.gateway.key = gtw.key
                this.register = true
                this.data.name = gtw.name
                this.data.description = gtw.description
                this.data.address = gtw.address
                this.data.location = `${gtw.location.latitude},${gtw.location.longitude}`
                this.data.inverters = gtw.inverters
                this.data.panels = gtw.panels
                this.data.rate = gtw.rate

                const latlng = {
                    lat: gtw.location.latitude,
                    lng: gtw.location.longitude,
                }
                this.map.marker = latlng
                this.map.center = latlng

            }
        }
    }
}
</script>

<style scoped>
.map{
    height: 150px;
    width: 100%;
}
</style>